import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ResultViewerComponent } from './result-viewer.component';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';


@NgModule({
  declarations: [
    ResultViewerComponent
  ],
  imports: [
    FormsModule,
    MatTableModule,
    CommonModule,
    MatCardModule
  ],
  providers: [],
  exports: [ResultViewerComponent]
})
export class ResultViewerModule { }
